module.exports = __webpack_public_path__ + "img/main.caf49a1e.png";